import React, { useState, useRef, useEffect } from "react";
import Select from "react-select";
import style from "./UploadResume.module.css";
import { customStyles } from '../../helpers/constants';
import Header from "../../components/Header";
import HeaderMobile from "../../components/HeaderMobile";
import { ApplyAsTalentDash } from "../../assets";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation,useQuery } from "@tanstack/react-query";
import { applyForJob, getSkillsList, uploadResume } from "../../api/containersApi";
import toast from "react-hot-toast";

export default function UploadResume() {

    const location = useLocation();    
    const navigate = useNavigate();
    const formRef = useRef(null);
    const fileInputRef = useRef(null);
    const [validated, setValidated] = useState(true);
    const [formData, setFormData] = useState({
        skillId: '',
        fullName: '',
        phone: '',
        email: '',
        qualification: '',
        experience: '',
        resume: '',
        message: '',
    });
    const [skillOption, setSkillOption] = useState(null);

    const { data: skillList, isLoading, isError, refetch } = useQuery({
        queryKey: ["getSkillsList"],
        queryFn: () => getSkillsList(localStorage.getItem("sessionToken")),
    });

    const skillListMapped = skillList?.map((i) => ({
        value: i?.id,
        label: i?.skill_name,
    }));

    const { mutate } = useMutation({
        mutationKey: ["uploadResume"],
        mutationFn: uploadResume,
        onSuccess: (data) => {
            toast.success("Thank you! Your application has been submitted successfully.", {
                position: "bottom-center",
                duration: 10000,
                style: {
                    border: '1px solid #FF9900',
                    padding: '16px',
                    color: "black",
                    fontFamily: "Helvetica",
                    maxWidth: "350px",
                  },
                  iconTheme: {
                    primary: '#FF9900',
                    secondary: '#FFFAEE',
                  },
            });
            setFormData({
                skillId: '',
                fullName: '',
                phone: '',
                email: '',
                qualification: '',
                experience: '',
                resume: '',
                message: '',
            });
            setSkillOption(null);
            fileInputRef.current.value = '';
            navigate("/jobs");
        },
    });

    const scrollToForm = () => {
        if (formRef.current) {
            formRef.current.scrollIntoView({ 
                behavior: 'smooth',
            });
        }
    }

    const submitForm = async (e) => {

        const finalFormData = new FormData();
        finalFormData.append("skillId", formData?.skillId);
        finalFormData.append("name", formData?.fullName);
        finalFormData.append("phone", formData?.phone);
        finalFormData.append("email", formData?.email);
        finalFormData.append("qualification", formData?.qualification);
        finalFormData.append("experience", formData?.experience);
        finalFormData.append("resume", formData?.resume);
        finalFormData.append("message", formData?.message);

        mutate({
            auth_key: localStorage.getItem("sessionToken"),
            finalFormData: finalFormData
        });
    }

    return(

        <div className={style.ApplyAsTalent_section}>

            <HeaderMobile />

            <div className={style.ApplyAsTalentDash_container}>
                
                <Header />

                {/* For larger screens */}
                <div className={style.ApplyAsTalentDash_content}>
                    <div data-aos="fade-right" data-aos-duration="1000" data-aos-delay="300">
                        <img src={ApplyAsTalentDash} alt="ApplyAsTalent" />
                    </div>
                    <div data-aos="fade-left" data-aos-duration="1000" data-aos-delay="200">
                        <p>Start Your Career Journey with NuFolks & Uncover Success!</p>
                        <p>Kickstart your career with NuFolks! Explore exciting opportunities, grow your skills, and unlock your path to success.</p>
                    </div>
                </div>           

                {/* For smaller screens */}
                <img src={ApplyAsTalentDash} alt="apply as talent" />
                <div className={style.ApplyAsTalentDash_content_2}>
                    <p>Start Your Career Journey with NuFolks & Uncover Success!</p>
                    <p>Kickstart your career with NuFolks! Explore exciting opportunities, grow your skills, and unlock your path to success.</p>
                </div>

            </div>

            <section className={style.textSection}>
                {/* data-aos="zoom-in" data-aos-duration="800" */}
                <p>Reach out to us as a candidate and we'll match you with the ideal company that aligns with your skills and career goals, paving the way for a rewarding and fulfilling professional journey. At NuFolks, we specialize in forging lasting connections that empower individuals to thrive in their chosen fields. We are committed to giving you the support and guidance you need to achieve your professional goals.</p>
            </section>

            <section ref={formRef} data-aos="fade-up" data-aos-duration="1500" className={style.formSection}>
                <h1>Submit Your Profile</h1>
                <p>Upload your job profile and resume using the form below to apply for exciting opportunities at NuFolks. Take the first step towards a fulfilling career with us!</p>
                <form 
                    data-aos="fade-up" 
                    data-aos-duration="1000" 
                    data-aos-offset="0"
                    onSubmit={(e) => {
                        e.preventDefault();
                        if(formData?.fullName === "" || formData?.phone === undefined || formData?.email === "" || formData?.skillId === null || formData?.qualification === "" || formData?.experience === "" || formData?.resume === null){
                            setValidated(false);
                            return;
                        }
                        else{
                            setValidated(true);
                            submitForm(e);
                        }
                    }}
                >
                    <div className={style.formComponent}>
                        <label htmlFor="">Name</label>
                        <input 
                            type="text" 
                            placeholder="Enter Your Full Name" 
                            value={formData?.fullName}
                            onChange={(e) => {
                                setFormData({...formData, fullName: e.target.value})
                            }}
                        />
                        { !validated && !formData?.fullName && <p>Please, enter your Full Name</p> }
                    </div>
                    <div className={style.formComponent}>
                        <label htmlFor="">Phone Number</label>
                        <input 
                            type="tel"
                            pattern="[0-9]*" 
                            maxLength={10}
                            placeholder="Enter valid 10-digit Phone Number" 
                            value={formData?.phone}
                            onChange={(e) => {
                                const filteredValue = e.target.value.replace(/\D/g, "");
                                setFormData({...formData, phone: filteredValue})
                            }}
                        />
                        { !validated && !formData?.phone && <p>Please, enter valid 10-digit Phone Number</p> }
                    </div>
                    <div className={style.formComponent}>
                        <label htmlFor="">Email Id</label>
                        <input 
                            type="email" 
                            placeholder="Eg. candidate@gmail.com" 
                            value={formData?.email}
                            onChange={(e) => {
                                setFormData({...formData, email: e.target.value})
                            }}
                        />
                        { !validated && !formData?.email && <p>Please, enter your email address</p> }
                    </div>
                    <div className={style.formComponent}>
                        <label htmlFor="">Qualifications</label>
                        <input 
                            type="text" 
                            placeholder="BE/B.Tech/MBA etc" 
                            value={formData?.qualification}
                            onChange={(e) => {
                                setFormData({...formData, qualification: e.target.value})
                            }}
                        />
                        { !validated && !formData?.qualification && <p>Please, enter your degree</p> }
                    </div>
                    <div className={style.formComponent}>
                        <label htmlFor="">Experience (Yrs) or Fresher</label>
                        <input 
                            type="text" 
                            placeholder="Eg. 2 or Fresher" 
                            value={formData?.experience}
                            onChange={(e) => {
                                setFormData({...formData, experience: e.target.value})
                            }}
                        />
                        { !validated && !formData?.experience && <p>Enter your valid experience</p> }
                    </div>
                    <div className={style.formComponent}>
                        <label htmlFor="employer_services">Select Your Skill</label>
                        <div className={style.employer_list_div}> 
                            <Select
                                style={{width: "100%"}}
                                id="employer_services"
                                options={skillListMapped}
                                placeholder="Select your skill"
                                styles={customStyles}
                                value={skillOption}
                                onChange={(skillObject) => {
                                    setSkillOption(skillObject);
                                    setFormData({...formData, skillId: skillObject?.value})
                                }}
                            />
                        </div>
                        { !validated && !formData?.skillId && <p>Please, enter your niche skill here</p> }                        
                    </div>
                    <div className={style.formComponent}>
                        <label htmlFor="">Upload Resume</label>
                        <input 
                            ref={fileInputRef}
                            id="fileMode" 
                            type="file" 
                            onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                    setFormData({...formData, resume: file});
                                }
                            }}
                        />
                        { !validated && !formData?.resume && <p>Please, upload your latest Resume</p> }
                    </div>
                    {/* style={{width: "100%", display: "flex", flexDirection: "column", gap: "10px"}} */}
                    <div className={style.formComponent2}>
                        <label htmlFor="txtar">Message</label>
                        <textarea  
                            id="txtar" 
                            placeholder="Enter! any messages for us"
                            value={formData?.message}
                            onChange={(e) => {
                                setFormData({...formData, message: e.target.value})
                            }}
                        ></textarea>
                    </div>
                    <div className={style.formComponent3}>
                        <button>Submit</button>
                    </div>
                </form>
            </section>
            
        </div>
    )
}
